import { useEffect } from 'react';
import { useTheme } from 'styled-components';

import { createPDPScrollHandler } from './createPDPScrollHandler';
import { useMediaQueryContext } from '~/utilities/context/dynamic/MediaQueryContext';

export const ProductScrollHandler = () => {
  const theme = useTheme();
  const { isDesktop } = useMediaQueryContext();

  useEffect(() => {
    if (!isDesktop) {
      return () => {};
    }

    const handleScroll = createPDPScrollHandler(theme);

    document.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [theme, isDesktop]);

  return null;
};
